<custom-header [VehicleType]="VehicleType" [pageHeaderTxt]="'home'"></custom-header>
<div class="vehicle-reg-container flex-direction-media">
  <div class="benefits-container hide-mobile-xm">
    <h4 class="benefits-heading">
      {{aemFragmentInfo?.mainHeading?.variations[VehicleType?.toLowerCase()]?.value}}
    </h4>
    <div class="benefits-description"
      [innerHTML]="aemFragmentInfo?.mainSubText?.variations[VehicleType?.toLowerCase()]?.value"></div>

    <div class="benefits-points-container">
      <div class="banner-img">
        <img
          alt="{{VehicleType === 'FWGI' ? 'car insurance premium calculator' : VehicleType === 'TWGI' ? 'Bike Insurance Calculator' : 'Vehicle Insurance Calculator'}}"
          width="300" height="328"
          src="{{aemFragmentInfo?.leftImageLightTheme?.variations[VehicleType?.toLowerCase()]?.value}}">
      </div>
      <div class="benefits-points" *ngIf="bannerPointText">
        <div class="point" *ngFor="let points of bannerText; let ind = index">
          <div class="pointer">{{ ind + 1 }}</div>
          <div class="point-body">
            <h6 class="point-heading">{{ bannerText[ind] }}</h6>
            <div class="point-desc">{{ bannerDesc[ind] }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="benefits-container hide-above-xm">
    <!-- [ngStyle]="{'background-image': 'url(' + aemFragmentInfo?.mobileViewBannerLightTheme?.variations[VehicleType?.toLowerCase()]?.value + ')'}" -->
    <img class="mobile-banner" alt="vehicle type"
      [src]="aemFragmentInfo?.mobileViewBannerLightTheme?.variations[VehicleType?.toLowerCase()]?.value" />
  </div>
  <div class="vehicle-reg-form-container">
    <div class="form-container" *ngIf="VehicleRegistrationForm">
      <form [formGroup]="VehicleRegistrationForm" id="{{this.vehicleRegistrationFormID}}">
        <div class="form-header">
          <h3>{{VehicleType === 'FWGI' ? 'Private Car Insurance' :
            VehicleType === 'TWGI' ? 'Two Wheeler Insurance':VehicleType === 'TXGI' ? 'Taxi Insurance' : VehicleType ===
            'CVGI'
            ?'Commercial Vehicle Insurance' :''}}</h3>
        </div>

        <!-- Vehicle Type -->
        <div class="form-control-container mt-25" *ngIf="bflJourney">
          <div class="fc-label">Vehicle Type
          </div>
          <!-- <div class="filter-dropdown-icon">
            <svg (click)="openDrawer('vehicleTypeDrawer')" xmlns="http://www.w3.org/2000/svg" width="10.56"
              height="6.407" viewBox="0 0 10.56 6.407">
              <path id="Path_31605" data-name="Path 31605" class="cls-1" d="M350.409,15.687l4.974,5.038-4.974,4.6"
                transform="matrix(0.035, 0.999, -0.999, 0.035, 13.459, -350.375)" />
            </svg>
          </div> -->
          <input type="text" [readonly]="true" (paste)="IsPaste($event)" (keypress)="FormValidators.IsAlphabet($event)"
            minlength="1"
            [ngClass]="FormValidators.FieldHasErrors(VehicleRegistrationForm,'vehicleType') ? 'is-invalid':'' "
            formControlName="vehicleType" aria-label="Vehicle Type" name="vehicleType" autocomplete="off"
            placeholder="Vehicle Type" required>
          <div *ngIf="FormValidators.FieldHasErrors(VehicleRegistrationForm,'vehicleType')" class="bottom-spc-10">
            <div class="text-danger" *ngIf="FormValidators.HasError(VehicleRegistrationForm,'vehicleType','required')">
              Vehicle
              Type is mandatory.</div>
          </div>
        </div>
        <div class="form-control-container mt-25">
          <div class="fc-label">Enter your {{VehicleType === 'FWGI' ?
            'car' : VehicleType === 'TWGI' ? 'bike':VehicleType === 'TXGI' ? 'Taxi' : VehicleType ===
            'CVGI' ?'Commercial Vehicle' :''}} number
          </div>
          <input name="" class="form-control-container formControl label-top" type="text" id="registrationNumberVehicle"
            formControlName="registrationNumber" name="registrationNumber" [maxlength]="12" minlength="1"
            oninput="javascript:this.value=this.value.toUpperCase();"
            onkeypress="if ((event.keyCode >= 32 && event.keyCode < 48) || (event.keyCode > 57 && event.keyCode < 65) || (event.keyCode > 90 && event.keyCode < 97)|| (event.keyCode > 122 && event.keyCode > 90 )) event.returnValue =false;"
            onkeyup="if ((event.keyCode >= 32 && event.keyCode < 48) || (event.keyCode > 57 && event.keyCode < 65) || (event.keyCode > 90 && event.keyCode < 97)|| (event.keyCode > 122 && event.keyCode > 90 )) event.returnValue =false;"
            placeholder="Enter your {{VehicleType === 'FWGI' ? 'car' : VehicleType === 'TWGI' ? 'Two wheeler':VehicleType === 'TXGI' ? 'Taxi' : VehicleType === 'CVGI' ? 'Commercial Vehicle' :''}} number"
            (keypress)="FormValidators.IsSpaceInput(VehicleRegistrationForm, 'registrationNumber');"
            (paste)="IsPaste($event)" autocomplete="off"
            on-focusout="validateRegNo();googleAnalyticfieldTiming('registrationNumber')"
            on-focus="SetFocusTime();onFocusField($event)"
            [ngClass]="FormValidators.FieldHasErrors(VehicleRegistrationForm,'registrationNumber') ? 'is-invalid':'' ">
          <div class="clearfix"></div>
          <div class="guidance-text">Ex. MH12AS1231</div>
          <!-- <div class="" *ngIf="FormValidators.FieldHasErrors(VehicleRegistrationForm,'registrationNumber')"> -->
          <div>
            <div class="error-msg"
              *ngIf="this.VehicleRegistrationForm.get('registrationNumber')?.hasError('pattern') && (inValidRegNoError == null || inValidRegNoError)">
              {{invalidPatternErrorMsg}}
            </div>
            <div class="error-msg" *ngIf="VehicleRegistrationForm.get('registrationNumber')?.hasError('required') && 
                          VehicleRegistrationForm.get('registrationNumber')?.touched && !inValidRegNoError">
              Please provide registration number
            </div>

          </div>
          <div class="error-msg"
            *ngIf="!FormValidators.HasError(VehicleRegistrationForm,'registrationNumber','required') && !FormValidators.HasError(VehicleRegistrationForm,'registrationNumber','pattern') && inValidRegNoError">
            {{inValidRegNoError}}
          </div>

          <span class="error-msg" *ngIf="ServiceError">{{ServiceError}}</span>
        </div>
      <!-- Customer Name Field -->
      <div class="form-control-container mt-25 mobileNumberContainer">
        <div class="fc-label">{{labelPlaceholder.labels.customerName}}</div>
        <input appInputAlphabet appRemoveWhiteSpace type="text" [placeholder]="labelPlaceholder.placeholders.customerName"
          (blur)="onBlurCustomerName()" formControlName="customerName" maxlength="100" class="form-control-container formControl label-top"
          [ngClass]="customerNameErrMsg && VehicleRegistrationForm['controls']?.customerName?.touched? 'is-invalid': '' ">
        <div class="guidance-text">{{labelPlaceholder.labels.customerNoteInfo}}</div>
        <span class="error-msg" *ngIf="VehicleRegistrationForm['controls']?.customerName?.dirty
                                    || VehicleRegistrationForm['controls']?.customerName?.touched">{{customerNameErrMsg}}
        </span>
      </div>

        <!-- Mobile Field -->
        <div class="form-control-container mt-25 mobileNumberContainer">
          <div class="fc-label">Mobile Number</div>
          <input #mob id="mobileNumber" type="tel" [readonly]="(isMobile ? isMobile : false) || isReadOnly"
            [disabled]="isMobile" (paste)="IsPaste($event)" (keypress)="FormValidators.IsNumeric($event)" maxlength="10"
            minlength="10" class="form-control-container formControl label-top mobPad" formControlName="mobileNumber"
            aria-label="Mobile Number" pattern="^\d{10}$"
            (keyup)="FormValidators.IsNumberMobile($event,VehicleRegistrationForm,'mobileNumber');ValidateMobile()"
            name="mobileNumber" autocomplete="off"
            (input)="ValidateMobile();FormValidators.onInputEntry($event, input5)" placeholder="Mobile Number"
            on-focusout="googleAnalyticfieldTiming('mobileNumber')" on-focus="SetFocusTime()"
            class="input-with-before-label"
            [ngClass]="FormValidators.HasError(VehicleRegistrationForm, 'mobileNumber','required') || IsCorrectMobile ? 'is-invalid': FormValidators.HasError(VehicleRegistrationForm, 'mobileNumber','pattern') ? 'is-invalid':'' "
            required>
          <div class="before-label">+91</div>
          <div class="guidance-text">Will be used for communication</div>
          <div class="text-danger"
            *ngIf="FormValidators.FieldHasErrors(VehicleRegistrationForm, 'mobileNumber') || IsCorrectMobile">
            <span class="error-msg"
              *ngIf="FormValidators.FieldHasSpecificError(VehicleRegistrationForm, 'mobileNumber', 'required')">
              Please provide your mobile number.
            </span>
            <span class="error-msg"
              *ngIf="FormValidators.FieldHasSpecificError(VehicleRegistrationForm, 'mobileNumber', 'minlength')">
              Enter your 10-digit mobile number
            </span>
            <span class="error-msg"
              *ngIf="!FormValidators.FieldHasErrors(VehicleRegistrationForm, 'mobileNumber') && IsCorrectMobile">
              {{IsCorrectMobile}}
            </span>
          </div>
        </div>
        <!-- Pin code -->
        <div class="form-control-container mt-25 pincodeContainer">
          <div class="fc-label">Pin Code</div>
          <input #input5 id="pinCode" type="tel" pattern="^[0-9]{6}$" maxlength="6" formControlName="pinCode"
            class="form-control-container text-capitalize formControl pincode label-top" autocomplete="off"
            (blur)="FormValidators.IsSpaceInput(VehicleRegistrationForm, 'pinCode')"
            (keyup)="OnPincodeChange($event);FormValidators.IsNumberMobile($event,VehicleRegistrationForm,'pinCode')"
            (keypress)="FormValidators.IsNumeric($event)" placeholder="Pin Code"
            on-focusout="googleAnalyticfieldTiming('pinCode')" on-focus="SetFocusTime()"
            [ngClass]="FormValidators.FieldHasErrors(VehicleRegistrationForm,'pinCode') ? 'is-invalid':'' " required>
          <div *ngIf="FormValidators.FieldHasErrors(VehicleRegistrationForm,'pinCode')">
            <div class="error-msg" *ngIf="FormValidators.HasError(VehicleRegistrationForm,'pinCode','required')">
              Please provide your PIN code
            </div>
            <div class="error-msg" *ngIf="FormValidators.HasError(VehicleRegistrationForm,'pinCode','pattern')">
              Please provide your correct PIN code
            </div>
          </div>
        </div>
        <!-- Terms and conditions -->
        <div *ngIf="!bflJourney" class="tnc-text mt-30">
          By clicking on 'GET QUOTE', you agree to our <span class="terms-link"
            (click)="openDrawer('termsDrawer')">Privacy Policy & Terms of Use.</span>
        </div>
        <div *ngIf="bflJourney" class="tnc-text mt-30">
          By clicking on “Get Quote”, you hereby declare that you have read, understood and agree with <span
            class="terms-link"
            onclick="window.open('https://www.bajajfinserv.in/insurance/insurance-terms-and-conditions-legal-and-compliance')">BFL
            Privacy Policy, Terms of Use, Disclaimer</span> etc on BFL website and authorize Bajaj Finance
          Ltd., its business partners/ group /subsidiary companies to contact you for providing
          products/services & to send promotional communications.
        </div>

        <!-- Commented against BFSDINSTSK-17363 jira -->

        <!-- whatsapp consent -->
        <!-- <div *ngIf="ShowConsent" class="custom-checkbox custom-checkbox-squared mt-20">
          <input class="inp-cbx" id="cbx-whatsapp" type="checkbox" style="display: none"
            [ngModelOptions]="{standalone: true}" [(ngModel)]="whatsAppConsent" (change)="checkUserConsent()" />
          <label class="cbx mb-15" for="cbx-whatsapp">
            <span>
              <svg width="12px" height="9px" viewbox="0 0 12 9">
                <polyline points="1 5 4 8 11 1"></polyline>
              </svg>
            </span>
            <span>
              I hereby consent to receive policy & marketing related communications via
              <img class="inline-img" src="assets/img/svg/whatsapp-logo.svg" width="25" alt="whatsapp-icon" />
              WhatsApp </span>
          </label>
        </div> -->
      </form>
      <section *ngIf="showLoader">
        <app-loader></app-loader>
      </section>
      <div class="custom-btn-container btn-centered mt-15">
        <div class="error-msg">{{vehicletypeError}}</div>
        <button type="button" [disabled]="(isMobile ? !VehicleRegistrationForm.valid : !enableGetQuoteButton)"
          (click)="Next();" class="custom-btn btn-bg btn-large btn-full-width mt-20"
          [ngClass]="{'disabled': (isMobile ? !VehicleRegistrationForm.valid : !enableGetQuoteButton)}">GET
          QUOTE</button>
      </div>
      <div *ngIf="!bflJourney" class="tnc-text mt-20">By submitting this form I agree
        to Terms of Use</div>
    </div>
  </div>
</div>
<section *ngIf="ShowPageloader">
  <app-loader></app-loader>
</section>
<custom-popup [config]="Config" [title]="'Mobile Verification'" [showClose]="false" [subtitle]="''"
  [id]="'mobileVerification'" class="contentmodal">
  <div class="modal-body">
    <!-- Mobile Verification Form -->
    <form *ngIf="MobileVerificationForm" [formGroup]="MobileVerificationForm">
      <!-- Mobile Field -->
      <div class=" ">
        <div id="verfyMobileNumber" class="label-text clearfix pull-left">Mobile Number</div>
        <div class="top-padding-spc">
          <h3 class="mobile-number-lable">+91 {{VehicleRegistrationForm.controls['mobileNumber'].value}}</h3>
        </div>
      </div>
      <!-- OTP Field -->
      <div class="form-group top-spc-20">
        <div class="input-group"
          [ngClass]="FormValidators.FieldHasErrors(MobileVerificationForm,'otp') || WrongOtpMsg || MobileOtpTrails >= 5 ? 'text-danger verify-mobile-danger':'' ">
          <input id="verifyOTP" type="text" maxlength="6" formControlName="otp"
            class="mobile-text form-control-container text-capitalize formControl otp-input" id="otp" aria-label="otp"
            autocomplete="off" name="otp" pattern="^[0-9]{6}$" (keypress)="FormValidators.IsNumeric($event)" required>
          <label class="formLabel"
            [ngClass]="(MobileVerificationForm.controls['otp'].value) ? 'atTopMargin' : 'atBottomMargin'">Your OTP
            has
            been sent, please enter OTP</label>
        </div>
        <div class="row"
          *ngIf="WrongOtpMsg || (MobileOtpTrails >= 5) || FormValidators.FieldHasErrors(MobileVerificationForm,'otp')">
          <div class="">
            <span class="text-danger fontStyle verify-mobile-danger"
              *ngIf="WrongOtpMsg && MobileOtpTrails < 5">{{WrongOtpMsg}}</span>
            <span class="text-danger fontStyle verify-mobile-danger"
              *ngIf="FormValidators.FieldHasErrors(MobileVerificationForm,'otp')">
              Please provide OTP.
            </span>
            <span class="text-danger fontStyle verify-mobile-danger" *ngIf="MobileOtpTrails >= 5">
              You've exhausted all 5 attempts to enter the correct OTP. Please resume your application after 10
              minutes.
            </span>
          </div>
        </div>
        <div class="row" *ngIf="OtpRetryMsg && OTPResend > 0">
          <span class="text-danger" *ngIf="OtpRetryMsg">{{OtpRetryMsg}}</span>
        </div>
        <br />
        <div class="row top-minus-10"
          [ngClass]="WrongOtpMsg || MobileOtpTrails >= 5 || FormValidators.FieldHasErrors(MobileVerificationForm,'otp') ? 'top-10' : ''">
          <div class="" [ngClass]="MobileOtpTrails >= 5 ? 'disabled-text' : ''">
            <label class="subTitle">
              <a id="btnResendOtp" (click)="SendMobileOTP()" class="text-left otp-btn-spec"
                [ngClass]="((OTPResend || MobileOtpTrails) >= 5 || ServiceErrorCode === 'QDM-518' )?'disabledDiv':''">Resend
                OTP</a>
            </label>
          </div>
          <br />
          <div class=" text-success top-10 verify-mobile-danger" *ngIf="IsOTPResend && MobileOtpTrails !== 5">
            OTP resend successfully! </div>
          <div class=" text-success top-10 text-danger fontStyle verify-mobile-danger"
            *ngIf="IsOTPResend && OTPResend === 5">You've exhausted all 5 attempts to enter the correct OTP. Please
            resume your application after 10 minutes.</div>
          <br />
        </div>
      </div>
      <div class="top-30">
        <div *ngIf="showLoader" class="pull-right">
          <img class="" alt="button loader" src="assets/img/Button-Loader.gif" />
        </div>
        <div class="" *ngIf="!showLoader">
          <button id="btnVerifyOTP" class="input-group-addon btn btn-pos verify-btn"
            (click)="VerifyOTP(MobileVerificationForm.value)"
            [disabled]="!MobileVerificationForm.valid || WrongOtpMsg || MobileOtpTrails >= 5">
            <i class="fontIcon-39"
              [ngClass]="MobileVerificationForm.valid && !WrongOtpMsg && MobileOtpTrails < 5 ? 'icon-gpgpfonts-Bajaj_Icon_GPGP_01_Previous Rotate-180 top-margin-2' : 'icon-gpgpfonts-Bajaj_Icon_GPGP_01_Next'">
              <span class="path1"></span>
              <span class="path2"></span>
              <span class="path3"></span>
            </i>
          </button>
        </div>
      </div>
    </form>
  </div>
</custom-popup>
<custom-popup [config]="Config" [title]="'Renewal'" [showClose]="false" [subtitle]="''" [id]="'renewal'">
  <div class="modal-body height-medium">
    <div class="text-center">
      <div class="">
        <h5 class="margin0">Your policy is not yet due for renewal, please contact nearest branch for further
          details.
        </h5>
      </div>
      <div class="">
        <button type="button" class="btn btn-primary text-uppercase" (click)="NextAction('')">
          <h5 class="done-btn">Explore More</h5>
        </button>
      </div>
      <div *ngIf="showLoader">
        <img class="" src="assets/img/Button-Loader.gif" alt="button loader" />
      </div>
    </div>
  </div>
</custom-popup>
<app-drawer [isModal]="true" [drawerId]="'vehicleTypeDrawer'" [width]="'half'">
  <div class="drawer-info">
    <div class="form-container border-radius10">
      <div (click)="removeClass();">
        <svg class="close-icon" viewPort="0 0 12 12" width="12px" height="12px">
          <line x1="1" y1="11" x2="11" y2="1" stroke-width="2" />
          <line x1="1" y1="1" x2="11" y2="11" stroke-width="2" />
        </svg>
      </div>
      <div class="drawer-header">
        Vehicle Type
      </div>
      <div class="form-radio-container2" *ngFor="let vehicle of vehicleTypeData;let i = index">
        <div class="sum-amount-card1" [ngClass]="vehicle.name === vehicleSelected ? 'active-item':''">
          <label class="card-option" for="{{vehicle.productCategoryCode}}">{{vehicle.name}}
            <input type="radio" id="{{vehicle.productCategoryCode}}" name="vehicleType"
              [checked]="vehicle.name === vehicleSelected" [value]="vehicle.name" on-focus="SetFocusTime()"
              (change)="setVehicleType($event)" />
          </label>
        </div>
      </div>
      <div class="btn-container mt-15">
        <button type="button" class="custom-btn btn-bg btn-medium btn-full-width"
          (click)="confirmVehicleType()">CONFIRM</button>
      </div>
    </div>
  </div>
</app-drawer>
<!-- Policy & terms drawer -->
<app-drawer [isModal]='true' [drawerId]="'termsDrawer'" [width]="'half'">
  <div class="drawer-info p-3 pt-4 pb-5">
    <div (click)="closePopUp();">
      <svg class="close-icon" viewPort="0 0 12 12" width="12px" height="12px">
        <line x1="1" y1="11" x2="11" y2="1" stroke-width="2" />
        <line x1="1" y1="1" x2="11" y2="11" stroke-width="2" />
      </svg>
    </div>
    <h5 class="policyHeading">Privacy Policy & Terms of use</h5>
    <div class="tnc-label" [innerHTML]="termsContent">
    </div>
  </div>
</app-drawer>
<seo-car-bfl *ngIf="VehicleType === 'FWGI' && bflJourney"></seo-car-bfl>
<seo-bike-bfl *ngIf="VehicleType === 'TWGI' && bflJourney"></seo-bike-bfl>
<seo-car-bfdl *ngIf="VehicleType === 'FWGI' && !bflJourney"></seo-car-bfdl>
<seo-bike-bfdl *ngIf="VehicleType === 'TWGI' && !bflJourney"></seo-bike-bfdl>
<custom-footer></custom-footer>